import { Capacitor } from "@capacitor/core";
import { Accessibility, PqSecureStorage } from "capacitor-pq-secure-storage";

const KEY = "mfsetu_client_current_identity_v1";
const WEB_KEY = "mfsetu_client_current_identity_web_v1";

export const readClientIdentity = async () => {
  try {
    if (Capacitor.isNativePlatform()) {
      const { value } = await PqSecureStorage.getItem({ key: KEY });
      return value ? JSON.parse(value) : null;
    }
    const value = localStorage.getItem(WEB_KEY);
    return value ? JSON.parse(value) : null;
  } catch { return null; }
};

export const saveClientIdentity = async (value) => {
  const clean = {
    deviceIdentityCredential: String(value?.deviceIdentityCredential || ""),
    userId: String(value?.userId || "").toUpperCase(),
    displayName: String(value?.displayName || ""),
  };
  if (!clean.deviceIdentityCredential || !clean.userId) throw new Error("Current login identity is incomplete.");
  if (Capacitor.isNativePlatform()) {
    const payload = JSON.stringify(clean);
    let firstError = null;
    try {
      const old = await PqSecureStorage.hasItem({ key: KEY });
      if (old?.exists) await PqSecureStorage.removeItem({ key: KEY });
      await PqSecureStorage.setItem({ key: KEY, value: payload, requireBiometric: false, accessibility: Accessibility.WhenUnlockedThisDeviceOnly });
      return;
    } catch (error) {
      firstError = error;
    }

    // Some Android keystore implementations reject an explicit accessibility
    // class even though a normal non-biometric secure item is supported.
    // Retry once with the plugin default; the identity still stays in native
    // encrypted/keystore-backed storage and never falls back to localStorage.
    try {
      try {
        const old = await PqSecureStorage.hasItem({ key: KEY });
        if (old?.exists) await PqSecureStorage.removeItem({ key: KEY });
      } catch (_) {}
      await PqSecureStorage.setItem({ key: KEY, value: payload, requireBiometric: false });
      return;
    } catch (retryError) {
      const detail = String(retryError?.message || firstError?.message || retryError || firstError || "Secure storage write failed");
      throw new Error(`Secure device identity could not be stored: ${detail}`);
    }
  } else {
    localStorage.setItem(WEB_KEY, JSON.stringify(clean));
  }
};
